export default __webpack_public_path__ + "static/media/Boston.98e8352c.webp";